import {
  BellOutlined,
  ChatQuestionOutlined,
  InvoiceOutlined,
  PenLineOutlined,
  PhoneOutlined,
  TrashOutlined,
} from "@bonusx-global/bx-icons";
import { EXTERNAL_PATH_COLLECTION } from "../../../constants/env";

export interface ISettingsRoute {
  text: string;
  path: string;
  icon: JSX.Element;
  isExternal: boolean;
}

export const CONTACT_DETAILS_TEXT = "I tuoi recapiti";
export const SIGNATURE_TEXT = "La tua firma";
export const NOTIFICATIONS_TEXT = "Gestisci notifiche";
export const CONTACT_US_TEXT = "Centro di supporto";
export const DELETE_ACCOUNT_TEXT = "Cancella account";
export const MANAGE_SUBSCRIPTION_TEXT = "Gestisci abbonamento";

export const CONTACT_DETAILS_PATH = "contact-details";
const SIGNATURE_PATH = "signature";
const NOTIFICATIONS_PATH = "notifications";
const DELETE_ACCOUNT_PATH = "delete-account";
export const MANAGE_SUBSCRIPTION_PATH = "manage-subscription";

export const settingsRoutes: ISettingsRoute[] = [
  {
    text: CONTACT_DETAILS_TEXT,
    path: CONTACT_DETAILS_PATH,
    icon: <PhoneOutlined />,
    isExternal: false,
  },
  {
    text: SIGNATURE_TEXT,
    path: SIGNATURE_PATH,
    icon: <PenLineOutlined />,
    isExternal: false,
  },
  {
    text: NOTIFICATIONS_TEXT,
    path: NOTIFICATIONS_PATH,
    icon: <BellOutlined />,
    isExternal: false,
  },
  {
    text: MANAGE_SUBSCRIPTION_TEXT,
    path: MANAGE_SUBSCRIPTION_PATH,
    icon: <InvoiceOutlined />,
    isExternal: false,
  },
  {
    path: EXTERNAL_PATH_COLLECTION.get("contact_us") ?? "",
    icon: <ChatQuestionOutlined />,
    text: CONTACT_US_TEXT,
    isExternal: true,
  },
  {
    text: DELETE_ACCOUNT_TEXT,
    path: DELETE_ACCOUNT_PATH,
    icon: <TrashOutlined />,
    isExternal: false,
  },
];
